<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-10 18:06:37
 * @Description: 图片编辑页面
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class="position-relative photo_edit w-100 h-100">
    <!-- 标记icon -->
    <m-view :src="EditViewProps.imgUrl" height="100%" width="100%" id="canvansView" v-if="showEdit">
      <m-toolbar slot="footer" class="tool_bar" v-if="showEditTool">
        <m-rect-tool></m-rect-tool>
        <m-ellipse-tool></m-ellipse-tool>
        <m-arrowline-tool></m-arrowline-tool>
        <m-pencil-tool></m-pencil-tool>
        <m-text-tool :size="[16, 24, 30]"></m-text-tool>
        <m-undo-tool :hideBadge="true"></m-undo-tool>
        <m-clear-tool></m-clear-tool>
        <el-button slot="end" @click="openSaveMarkerDialog" icon="el-icon-check"></el-button>
        <el-button slot="end" @click="closeEdit" icon="el-icon-close"></el-button>
      </m-toolbar>
    </m-view>
    <img :src="imgByPr" alt id="rotateImg" v-if="showImgByPr" />
    <component
      :is="showComponents"
      :title="componentTitle"
      :disableName="disableName"
      :formLabelAlign="saveMarkForm"
      :markDatil="markDatil"
      :imgUrl="editImgUrl"
      :documentId="documentId"
      v-if="showDialog"
      ref="componentsRef"
      @closeComponents="closeComponents"
      :currentBrowseFile="currentBrowseFile"
      :standardId="standardId"
    ></component>
  </div>
</template>
<script>
const markerDetail = () => {
  return import('./markerDetail')
}
const saveOrShareMarker = () => {
  return import('./saveOrShareMarker')
}
export default {
  components: {
    markerDetail,
    saveOrShareMarker,
  },
  props: ['EditViewProps', 'currentBrowseFile', 'standardId'],
  watch: {
    EditViewProps: {
      deep: true,
      async handler(info) {
        console.log('info', info)
        if (info.showMark === true) {
          this.showEditTool = false
          this.showDialog = true
          this.markDatil = {
            name: info.name,
            remark: info.remark,
          }
          this.showComponents = markerDetail
        }
      },
    },
  },
  data() {
    return {
      showEditTool: true,
      showEdit: true,
      showDialog: false,
      showImgByPr: false,
      componentTitle: '保存标记',
      disableName: false, // 分享名称是否允许输入
      showComponents: saveOrShareMarker,
      saveMarkForm: {
        id: '',
        name: '',
        remark: '',
        sharePerson: [],
        cameraPosition: '',
        fileId: '',
        markType: '',
      },
      markDatil: {
        name: '',
        remark: '',
      },
      editImgUrl: '',
      imgByPr: '',
    }
  },
  computed: {
    documentId() {
      return this.$route.query.documentId
    },
  },
  async created() {
    if (this.EditViewProps.showMark === true) {
      this.showEditTool = false
      this.showDialog = true
      this.markDatil = {
        name: this.EditViewProps.name,
        remark: this.EditViewProps.remark,
      }
      this.showComponents = markerDetail
    } else if (this.EditViewProps.markType === 2) {
      // 图像翻转
      this.showEdit = false
      this.showImgByPr = true
      this.imgByPr = this.EditViewProps.imgUrl
      setTimeout(async () => {
        const captureDom = document.querySelector('#rotateImg')
        this.EditViewProps.imgUrl = await this.getConvertToImage(captureDom)
        this.showImgByPr = false
        this.showEdit = true
      }, 0)
    }
  },
  methods: {
    /**
     * @description: 打开保存图片的弹框
     * @param {*}
     * @return {*}
     */

    openSaveMarkerDialog() {
      this.showComponents = saveOrShareMarker
      this.saveMarkForm.cameraPosition = JSON.stringify(this.EditViewProps.fileLocation)
      this.saveMarkForm.fileId = this.EditViewProps.fileId
      this.saveMarkForm.markType = this.EditViewProps.markType
      const canvasEdit = document.getElementsByClassName('lower-canvas')[0]
      this.editImgUrl = canvasEdit.toDataURL('image/png')
      this.showDialog = true
      this.showEditTool = false
    },
    closeComponents(val) {
      if (val === 'end') {
        this.$emit('hideEditView', true)
      }
      this.showDialog = false
      this.showEditTool = true
    },
    closeEdit() {
      this.$emit('hideEditView', true)
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(container).width)
      const height = parseInt(window.getComputedStyle(container).height)
      // // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: true,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        return canvas.toDataURL('image/png')
      })
    },
  },
}
</script>
<style lang="scss" scoped>

.tool_bar {
  background: #ffffff00;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
}
.photo_edit {
  z-index: 2001;
}
#rotateImg {
  transform: rotateX(180deg);
}
/deep/.el-card__body {
  padding: 20px !important;
}

</style>
